import { JustpayProfileEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-profile-endpoint-service"

export class JustpayProfileService {
    constructor () {
        this.justpayProfileEndpointService = new JustpayProfileEndpointService()
    }

    async getInit (id) {
        const response = await this.justpayProfileEndpointService.getProfiles({ id: id })
        response.data = response.data.length > 0 ? response.data[0] : {}
        return response
    }

    async getProfiles (arg) {
        return this.justpayProfileEndpointService.getProfiles(arg)
    }

    async changeProfile (request) {
        return this.justpayProfileEndpointService.changeProfile(request)
    }

    async createProfile (request) {
        return this.justpayProfileEndpointService.createProfile(request)
    }

    async downloadData (request) {
        return this.justpayProfileEndpointService.downloadData(request)
    }
}
